<script>
	import OffsetThresholdWrapperGBLE from './OffsetThresholdWrapperGBLE.svelte';

	export let device;

	const min = device?.fahrenheitEnabled ? -58 : -50;
	const max = device?.fahrenheitEnabled ? 122 : 50;
</script>

<OffsetThresholdWrapperGBLE {device} setting="offset" type="temperature" {min} {max} />
